exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".feeBlock {\r\n    display: flex;\r\n}\r\n.feeBlock div {\r\n    margin: auto 10px;\r\n}\r\n.feeBlock div label {\r\n    padding-top: 5px;\r\n}\r\n\r\n.row.wrap {\r\n    flex-wrap: wrap;\r\n}", ""]);

// exports
